export enum ProjectType {
  ci = 'CI_SITE',
  credit = 'CREDIT',
  market = 'MARKET',
  meshgrid = 'MESHGRID',
  minigrid = 'MINIGRID',
  pue = 'PRODUCTIVE_USE_EQUIPMENT',
  shs = 'SOLAR_HOME_SYSTEM',
  digitaldevice = 'DIGITAL_DEVICE',
  cookstove = 'COOKSTOVE',
  residential = 'RESIDENTIAL',
  other = 'OTHER'
}
